import { BeraJobSummaryDTO } from './types/response';

interface UnfinishedFileNavigation {
	hasUnfinishedFiles: boolean;
	firstUnfinishedFileId: string | null;
}

export function getUnfinishedFileNavigation(jobSummary: BeraJobSummaryDTO | undefined): UnfinishedFileNavigation {
	if (!jobSummary) {
		return { hasUnfinishedFiles: false, firstUnfinishedFileId: null };
	}

	const reportsByFileId = new Map(
		(jobSummary.bera_report || []).map((report) => [report.file_id, report])
	);

	const fileWithoutReport = (jobSummary.bera_job_summary_files || []).find(
		(entry) => !reportsByFileId.has(entry.file.id)
	);

	if (fileWithoutReport) {
		return { hasUnfinishedFiles: true, firstUnfinishedFileId: fileWithoutReport.file.id };
	}

	const unconsolidatedReport = (jobSummary.bera_report || []).find(
		(report) => !report.consolidated
	);

	if (unconsolidatedReport) {
		return { hasUnfinishedFiles: true, firstUnfinishedFileId: unconsolidatedReport.file_id };
	}

	return { hasUnfinishedFiles: false, firstUnfinishedFileId: null };
}
